import React, { useState, useEffect } from 'react';

export default function ScritteOblique() {
    const posizionePartenza = -250;
    const dimensioni = [1200, 700, 800, 850, 600, 1200, 500, 700, 900, 600, 750, 930, 515, 1200, 675, 780];
    const idealWidth = 1920;
    const maxWidth = 330;
    const minWidth = 165;

    // Stato per memorizzare la larghezza attuale della finestra
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    // Funzione per gestire il cambiamento delle dimensioni della finestra
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Effetto per aggiungere e rimuovere l'ascolto degli eventi di ridimensionamento
    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // Pulisci l'ascoltatore degli eventi al momento della disconnessione dell'effetto
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Calcola la proporzione in base alla larghezza attuale della finestra
    const proportion = screenWidth / idealWidth;

    return (
        <div className='container_colonne_scritte' id="home">
            {dimensioni.map((elem, index) => {
                // Calcola la larghezza proporzionata
                let width = 330 * proportion;
                let widthSubstract = 30 * proportion
                widthSubstract = widthSubstract <= 30 ? widthSubstract : 30
                widthSubstract = widthSubstract <= 15 ? 15 : widthSubstract

                // Limita la larghezza massima a 330 e la larghezza minima a 180
                width = Math.min(Math.max(width, minWidth), maxWidth);

                // Calcola il ritardo per ciascuna colonna (ad esempio, 0.2s, 0.4s, 0.6s, ecc.)
                const delay = 0.3 * index + "s";

                // Applica la classe CSS e il ritardo
                const columnClassName = "column c" + index + " column-animation";
                const columnStyle = {
                    left: posizionePartenza + (width * index),
                    height: elem,
                    width: (width - widthSubstract),
                    animationDelay: delay, // Applica il ritardo all'animazione
                };

                return (
                    <div key={index} className={columnClassName} style={columnStyle} />
                );
            })}
        </div>
    );
}
